import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SubmitDocumentRequest } from './submitDocument.types';

/**
 * Submit a document for review.
 * Endpoint: POST /documents
 *
 * Sends the file as multipart/form-data with authority and notes.
 * `organizationId` is sent as X-Organization-ID header.
 */
export async function submitDocument(
  request: SubmitDocumentRequest,
  organizationId: string
): Promise<void> {
  const formData = new FormData();
  formData.append('File', request.file);
  formData.append('Authority', request.authority);
  formData.append('Notes', request.notes);

  await axiosInstance.post('/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Organization-ID': organizationId,
    },
  });
}
